import React from 'react';
import './App.css';
import DateGen from './DateGen';

function App() {
  return (
    <div className="App">
      <DateGen />
    </div>
  );
}

export default App;
